/**
 * Meta descriptions for the top-level landing pages, centralised so the
 * character budget is enforceable in one test rather than per page.
 *
 * 170 matches DESC_LIMIT in helpers/athleteProfileSeo.ts.
 */
export const LANDING_PAGE_DESC_LIMIT = 170;

export const ATHLETES_PAGE_DESCRIPTION =
  'Find athletes from every sport on MILLIONS. Shop official merch and memorabilia, book personal videos and experiences, and watch their streams and podcasts.';

export const MERCH_PAGE_DESCRIPTION =
  'Shop official merch from athletes, gyms and sports creators on MILLIONS. Latest drops, new releases and trending products, shipped globally.';

export const LANDING_PAGE_DESCRIPTIONS: Record<string, string> = {
  '/athletes': ATHLETES_PAGE_DESCRIPTION,
  '/merch': MERCH_PAGE_DESCRIPTION,
};
